import { render, staticRenderFns } from "./PosEdit.vue?vue&type=template&id=5170639e&scoped=true&"
import script from "./PosEdit.vue?vue&type=script&lang=js&"
export * from "./PosEdit.vue?vue&type=script&lang=js&"
import style0 from "./PosEdit.vue?vue&type=style&index=0&id=5170639e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5170639e",
  null
  
)

export default component.exports